import { ChangeDetectionStrategy, Component, OnInit, computed, input, output, signal } from '@angular/core';
import { getSnippetCategoryName } from 'lib/cosmos/snippet/snippet.utils';
import { SnippetDb } from 'lib/cosmos/snippet/snippetDb';
import { SelectItemField } from 'lib/ui/form/fields/select-item-field.component.js';
import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';

@Component({
	selector: 'mod-snippet-form',
	templateUrl: './snippet-form.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SnippetFormComponent extends TypeCoreComponent<SnippetDb.ISnippetItem | undefined> implements OnInit {
	public readonly isInDialog = input<boolean>(false);

	public readonly create = output<SnippetDb.ISnippetItem>();

	public readonly categorySelectionItems: readonly SelectItemField<SnippetDb.SnippetCategory>[] =
		SnippetDb.snippetCategories.map((m) => {
			return {
				data: m,
				title: getSnippetCategoryName(m),
				value: m
			};
		});

	public readonly form = {
		id: signal<string | undefined>(undefined),
		name: signal<string | undefined>(undefined),
		text: signal<string | undefined>(undefined),
		category: signal<SnippetDb.SnippetCategory | undefined>(undefined)
	};

	public readonly isEditForm = computed<boolean>(() => {
		if (this.form.id()) {
			return true;
		}
		return false;
	});

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const sharedData = this.sharedData();

		const form = this.form;

		const name = form.name();
		const text = form.text();
		const category = form.category();

		if (!text || !category || !name) {
			return undefined;
		}

		return this.dependencies.httpService
			.upsert<SnippetDb.ISnippetItem, SnippetDb.IBaseSnippetItem>({
				type: 'snippet',
				existingItem: sharedData?.data,
				createModel: {
					name: name,
					text: text,
					category: category
				},
				patchModel: (item) => {
					return {
						id: item.id,
						name: name,
						text: text,
						category: category
					};
				}
			})
			.pipe(
				map((response) => {
					super.notifyUpsert('Snippet', this.isEditForm());
					this.create.emit(response.data);

					super.updateSharedData({
						data: response.data,
						linkedItems: response.linkedItems
					});

					if (!this.isInDialog() && !this.isEditForm()) {
						this.dependencies.navigateService
							.actionRoute((routes) => routes.snippetRoutes.snippet.children.edit, response.data.id)
							.navigate();
					}
				})
			);
	});

	constructor() {
		super();

		this.sharedDataInit = (sharedData) => {
			this.form.id.set(sharedData?.data?.id);
			this.form.name.set(sharedData?.data?.system.name);
			this.form.text.set(sharedData?.data?.text);
			this.form.category.set(sharedData?.data?.category);
		};
	}
}
